import { Card } from './Card';
import { CardTitle } from './CardTitle';
import { CardBody } from './CardBody';

Card.Title = CardTitle;
Card.Body = CardBody;

export { Card };
